<script setup>
    import { useI18n } from 'vue-i18n';
    import { onMounted, onUnmounted } from 'vue';

    const { t } = useI18n();

    function closeDialog(decline) {
        let $declineDistiButton = document.querySelector(".disti-decline");
        let $closeDistiDialog = document.querySelector(".disti-close");
        let $downloadDistiPopup = document.querySelector(".disti-download-popup");
        let $downloadDistiPopupContent = $downloadDistiPopup.querySelector(".download-popup-content");

        if (
            !$downloadDistiPopupContent.contains(decline.target) ||
            $declineDistiButton.contains(decline.target) ||
            $closeDistiDialog.contains(decline.target)
        ) {
            decline.preventDefault();
            decline.stopPropagation();
            hideDialog();
        }
    }

    function hideDialog() {
        let $productDownloads = document.querySelector("section.product-downloads");
        let $declineDistiButton = document.querySelector(".disti-decline");
        let $closeDistiDialog = document.querySelector(".disti-close");
        let $downloadDistiPopup = document.querySelector(".disti-download-popup");

        $closeDistiDialog.removeEventListener('click', closeDialog);
        $declineDistiButton.removeEventListener('click', closeDialog);
        $downloadDistiPopup.removeEventListener('click', closeDialog);

        $productDownloads.classList.remove('show-secure-dialog');
        $productDownloads.classList.remove('show-disti-dialog');
        $downloadDistiPopup.classList.add("is-hidden");
        document.querySelectorAll(".secure-download-popup").forEach($securePopup => {
            if(!$securePopup.classList.contains("is-hidden")) {
                $securePopup.classList.add("is-hidden");
            }
        });
    }

    function openDialog(accept) {
        accept.preventDefault();
        accept.stopPropagation();

        let url = null;
        if (accept.target.getAttribute('href')) {
            url = accept.target.getAttribute('href');
        }
        if (url === null) {
            return;
        }

        window.open(url);
        hideDialog();
    }

    onMounted(() => {
        document.addEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hideDialog();
            }
        });
    });

    onUnmounted(() => {
        document.removeEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hideDialog();
            }
        });
    });
</script>

<template>
    <div class="download-popup disti-download-popup">
        <div class="download-popup-content">
            <h2 class="title is-3">
                {{ t('productDetails.Download.Disti.Dialog.Title') }}
            </h2>
            <p class="disti-dialog-text">
                {{ t('productDetails.Download.Disti.Dialog.Text') }}
            </p>
            <p class="internal-dialog-text">
                {{ t('productDetails.Download.Internal.Dialog.Text') }}
            </p>
            <div class="links-container">
                <button class="accept disti-accept button is-primary" @click="openDialog($event)">
                    {{ t('productDetails.Download.Disti.Dialog.Accept') }}
                </button>
                <button class="decline disti-decline button is-secondary" @click="closeDialog($event)">
                    {{ t('productDetails.Download.Disti.Dialog.Decline') }}
                </button>
            </div>
        </div>
        <button class="button close-dialog disti-close" @click="closeDialog($event)">
            <span>&times;</span>
        </button>
    </div>
</template>
